import {PcsSubjectElementType} from "../interface";
import DisplayNumber from "../../../../../components/common/number/DisplayNumber";

interface PropsType {
    pcsSubject: PcsSubjectElementType[]
    menuTitleText: string
}

export default function Tab2({pcsSubject, menuTitleText}: PropsType) {
    return <div className="content_wrap">
        <div className="table_top">
            <h6 className="table_stats">{menuTitleText}품목</h6>
            <div className="table_toolbar">
            </div>
        </div>
        <div className="table_scroll mb-0">
            <table className="table table-bordered my_table table_detail">
                <thead>
                <tr>
                    <th style={{width: "12%"}}>제품군</th>
                    <th>품목</th>
                    <th style={{width: "20%"}}>규격</th>
                    <th style={{width: "15%"}}>수량</th>
                </tr>
                </thead>
                <tbody>
                {pcsSubject.map(el =>
                    <tr>
                        <td className="text-center">{el.productGroupName}</td>
                        <td>{el.productName}</td>
                        <td className="text-center">{el.newTxtStandard}</td>
                        <td className="text-end"><DisplayNumber value={el.newIQty}/></td>
                    </tr>
                )}
                </tbody>
                <tfoot>
                <tr>
                    <td className="text-start grey" colSpan={3}></td>
                    <td className="text-end"><DisplayNumber
                        value={pcsSubject.reduce((acc, cur) => acc + cur.newIQty, 0)}/></td>
                </tr>
                </tfoot>
                {/* 내부수정: 사이즈 고정 해제, 빈 컬럼 삭제 */}
            </table>
        </div>
    </div>
}